import { call, put, takeLatest } from "redux-saga/effects";

import axiosApi from "../../utils/axios";
import {
  FailureAndroidAdditionalDetails,
  FailureApkInfo,
  FailureCrimes,
  FailurePermissions,
  FailurePlugins,
  FailureStaticCodeIssues,
  RequestAndroidAdditionalDetails,
  RequestApkInfo,
  RequestCrimes,
  RequestPermissions,
  RequestPlugins,
  RequestStaticCodeIssues,
  SuccessAndroidAdditionalDetails,
  SuccessApkInfo,
  SuccessCrimes,
  SuccessPermissions,
  SuccessPlugins,
  SuccessStaticCodeIssues,
} from "../actions/androidActions";

export function* crimes({ payload: id }) {
  try {
    const response = yield call(axiosApi.get, `/api/android/crimes/${id}`);
    yield put(SuccessCrimes(response?.data));
  } catch (e) {
    yield put(FailureCrimes(e));
  }
}

export function* staticCodeIssues({ payload: id }) {
  try {
    const response = yield call(axiosApi.get, `/api/android/static-code-issues/${id}`);
    yield put(SuccessStaticCodeIssues(response?.data));
  } catch (e) {
    yield put(FailureStaticCodeIssues());
  }
}

export function* permissions({ payload: id }) {
  try {
    const response = yield call(axiosApi.get, `/api/android/permissions/${id}`);
    yield put(SuccessPermissions(response?.data));
  } catch (e) {
    yield put(FailurePermissions());
  }
}

export function* plugins({ payload: id }) {
  try {
    const response = yield call(axiosApi.get, `/api/android/plugins/${id}`);
    yield put(SuccessPlugins(response?.data));
  } catch (e) {
    yield put(FailurePlugins());
  }
}

export function* apkinfo({ payload: id }) {
  try {
    const response = yield call(axiosApi.get, `/api/android/apkinfo/${id}`);
    yield put(SuccessApkInfo(response?.data));
  } catch (e) {
    yield put(FailureApkInfo());
  }
}

export function* additionalDetails({ payload: id }) {
  try {
    const response = yield call(axiosApi.get, `/api/android/additional-details/${id}`);
    yield put(SuccessAndroidAdditionalDetails(response?.data));
  } catch (e) {
    yield put(FailureAndroidAdditionalDetails());
  }
}

const androidSagas = [
  takeLatest(RequestCrimes, crimes),
  takeLatest(RequestStaticCodeIssues, staticCodeIssues),
  takeLatest(RequestPermissions, permissions),
  takeLatest(RequestPlugins, plugins),
  takeLatest(RequestApkInfo, apkinfo),
  takeLatest(RequestAndroidAdditionalDetails, additionalDetails),
];

export default androidSagas;
